export default {
  submitText: '保存',
  emptyBtn: false,
  // submitBtn: false,
  submitBtn: true,
  column: [
    // {
    //   label: '项目名称',
    //   display: true,
    //   disabled: true,
    //   clearable: false,
    //   prop: 'communityName',
    //   span: 6,
    // },
    // {
    //   label: '地址',
    //   display: true,
    //   disabled: true,
    //   clearable: false,
    //   prop: 'targetName',
    //   span: 12,
    // },
    // {
    //   label: '客户',
    //   display: true,
    //   disabled: true,
    //   clearable: false,
    //   prop: 'payManName',
    //   span: 6,
    // },
    // {
    //   label: '收费时间',
    //   display: true,
    //   disabled: true,
    //   clearable: false,
    //   prop: 'payTime',
    //   type: 'date',
    //   format: 'yyyy-MM-dd',
    //   valueFormat: 'yyyy-MM-dd',
    //   span: 6,
    // },
    // {
    //   label: '收款人',
    //   display: true,
    //   clearable: false,
    //   disabled: true,
    //   prop: 'cashierName',
    //   span: 6,
    // },
    // {
    //   label: '收费方式',
    //   display: true,
    //   disabled: true,
    //   clearable: false,
    //   prop: 'payTypeName',
    //   span: 6,
    // },
    // {
    //   label: '票据号',
    //   display: true,
    //   clearable: true,
    //   disabled: false,
    //   prop: 'invoiceNo',
    //   span: 6,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请输入票据号',
    //       trigger: 'blur',
    //     },
    //   ],
    // },
    // {
    //   label: '收费明细',
    //   display: true,
    //   disabled: true,
    //   prop: 'payDetailStr',
    //   type: 'textarea',
    //   rows: 4,
    //   span: 24,
    // },
    // {
    //   label: '收费备注',
    //   display: true,
    //   prop: 'payRemark',
    //   type: 'textarea',
    //   rows: 4,
    //   span: 24,
    // },
    
    {
      label: '',
      labelWidth:0,
      prop: 'formHead',
      formslot: true,
      // component: 'elTable',//ele日期
      span:24,
    },
    {
      label: '',
      labelWidth:0,
      prop: 'detailList',
      formslot: true,
      // component: 'elTable',//ele日期
      span:24,
    }
  ],
};
